import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1>W to CWXxx Personal Site!</h1>
      <p>This is my portfolio website built with React.</p>
    </div>
  );
}

export default App;